import React from 'react';

import { Spacer, Text } from '@ontruck/orc';
import moment from 'moment';

const ScheduledTask = ({ changes: { task, owner, scheduled_for }, ...props }) => {
  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        Task: {task}
      </Text>
      <Text color="grey800" display="block">
        Owner: {owner}
      </Text>
      <Text color="grey800" display="block">
        Timer for: {formatDate(scheduled_for)}
      </Text>
    </Spacer>
  );
};

export function formatDate(timestamp) {
  const dateFormat = 'DD MMM HH:mm';

  return moment(timestamp).format(dateFormat);
}

export default ScheduledTask;
